module.exports = __webpack_public_path__ + "static/media/SL-pencil.bb42a9d0.svg";